import React from 'react';
import { ThemeProvider } from 'styled-components';
import { AuthProvider } from './src/context/AuthContext';
import { ModalProvider } from './src/context/ModalContext';
import { SchoolProvider } from './src/context/SchoolContext';
import theme from './src/styles/theme';
import GlobalStyle from './src/styles/GlobalStyle';
import "./src/styles/global.css";
import ProtectedRoute from "./src/components/ProtectedRoute";
import ModalContainerWithI18n from "./src/components/ModalContainerWithI18n";
import { AdminProvider } from "./src/context/AdminContext";
import schoolConfig from "./src/config/schools";
import { defaultLanguageFor } from "./src/config/schools/languages";

// El sitio arranca en el idioma de la escuela y solo cambia si el usuario usa
// el toggle (decisión de Vic, 2026-09-24). gatsby-plugin-react-i18next, si no
// encuentra idioma guardado, lo detecta del navegador y redirige (un estudiante
// de EFS con el navegador en inglés terminaba en /en/), y encima guarda ese
// idioma detectado como si fuera una elección. Aquí se siembra una sola vez el
// idioma de la escuela; desde ahí solo lo cambia `changeLanguage()` del toggle.
const LANGUAGE_KEY = "gatsby-i18next-language"; // la clave que lee el plugin
const SEEDED_KEY = `language-seeded-${schoolConfig.id}`;

export const onClientEntry = () => {
  try {
    if (!window.localStorage.getItem(SEEDED_KEY)) {
      window.localStorage.setItem(LANGUAGE_KEY, defaultLanguageFor(schoolConfig.id));
      window.localStorage.setItem(SEEDED_KEY, "1");
    }
  } catch (e) {
    // Sin localStorage (modo privado estricto): el plugin cae a su detección.
  }
};

export const wrapRootElement = ({ element }) => (
  <SchoolProvider>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AuthProvider>
        <ModalProvider>
          {element}
          <ModalContainerWithI18n />
        </ModalProvider>
      </AuthProvider>
    </ThemeProvider>
  </SchoolProvider>
);

export const wrapPageElement = ({ element, props }) => {
  if (props.path === "/tutor") {
    return <ProtectedRoute requiredRole="tutor">{element}</ProtectedRoute>;
  }
  if (props.path?.startsWith("/admin")) {
    return <AdminProvider>{element}</AdminProvider>;
  }
  return element;
};
